<div class="container">
  <div
    class="offset-sm-1 col-sm-10 pt-5 webview text-center"
    [@flyInOut]="'in'"
  >
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
      {{ question }}
    </h1>
    <div _ngcontent-c5="" class="col-md-5 col-lg-4 m-auto" id="datepick">
      <div class="form-group mb-0" style="margin-bottom: 0px !important">
        <!-- <mat-form-field class="example-full-width datePicker" appearance="fill">
          <mat-label>MM/DD/YYYY</mat-label>
          <input
            matInput
            [matDatepickerFilter]="myFilter"
            [matDatepicker]="picker"
            [min]="minDate"
            [max]="maxDate"
            [(ngModel)]="datemodel"
            (ngModelChange)="dateChanged()"
            disabled
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>
        </mat-form-field> -->
        <app-datepicker
          [inputView]="inputView"
          [pickerPlaceholder]="placeholderText"
          [inputValue]="datemodel"
          (selectedItem)="valueChanged($event)"
        ></app-datepicker>
      </div>
    </div>
    <p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
      <a href="javascript:void(0)" (click)="openModal(template)">
        tap to see what fees may apply</a
      >
    </p>
    <button *ngIf="showbutton"
      class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase"
      [ngClass]="{ sectbtn: user_bot }"
      (click)="next()"
    >
      Next
    </button>
    <div class="mt-5">
      <div
        class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center"
      >
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">HEADS UP</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-2 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0 mb-1">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="row m-auto mobile-dpicker">
    <div class="col-12">
      <div class="col-9 offset-col-3 mb-2 px-0 pull-right">
        <!-- <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>MM/DD/YYYY</mat-label>
          <input
            matInput
            [matDatepickerFilter]="myFilter"
            [matDatepicker]="mobpicker"
            [min]="minDate"
            [max]="maxDate"
            [(ngModel)]="datemodel"
            (ngModelChange)="dateChanged()"
            disabled
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="mobpicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #mobpicker disabled="false"></mat-datepicker>
        </mat-form-field> -->
        <app-datepicker
          [pickerPlaceholder]="placeholderText"
          [inputValue]="datemodel"
          (selectedItem)="valueChanged($event)"
        ></app-datepicker>
      </div>
    </div>
    <p class="m-auto text-muted tapmsg pb-3" style="color: #0055ff !important">
      <a (click)="openModal(template)">tap to see what fees may apply</a>
    </p>
    <div class="col-12">
      <div  class="col-12sd" style="text-align: right;width: 97%">
        <div *ngIf="user_bot" class="ash_box text-right mb-3">
          <h1 class="ansMob text-right">{{ ans_date }}6</h1>
        </div>
      </div>
    </div>
 
    <div class="col-12 mb-3">
      <div class="m-auto blockbg boxclr p-2">
        <img
          src="assets/images/flash.png"
          class="mb-1"
          style="margin-left: 48%"
        />
        <p class="text-center tiphead">HEADS UP</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0 modal-border">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
      <br />
      <h4 class="modal-title pull-left semi-bold font20">
        Move In and Switch Fees by Utility
      </h4>
    </div>
  </div>
  <div class="modal-body">
    <p class="font15">
      This fee schedule reflects what you could be charged from your local
      Utility to start new service or switch providers. These prices are subject
      to change. Please check with your respective Utility for the
      most-up-to-date pricing.
    </p>
    <div class="row">
      <div class="col-md-6 col-6">
        <p class="font15 calibre-semibold mb-0">New Service</p>
        <p class="font15 font-weight-normal-calibre">
          <span>Standard Move In</span><br />
          <span class="calibre-italic"
            >At least 2 days after time of enrollment</span
          >
        </p>
        <p class="font15 font-weight-normal-calibre">
          <span>Priority Move In</span><br />
          <span class="calibre-italic"
            >Power needs to be turned on within 24-48 hours</span
          >
        </p>
      </div>
      <div class="col-md-6 col-6">
        <p class="font15 calibre-semibold mb-0">Switching Providers</p>
        <p class="font15 font-weight-normal-calibre">
          <span>Standard Switch</span><br />
          <span class="calibre-italic">3-7 Business Days after enrollment</span>
        </p>
        <p class="font15 font-weight-normal-calibre">
          <span>Self-Select Switch</span><br />
          <span class="calibre-italic"
            >More than 7 business days in the future</span
          >
        </p>
      </div>
    </div>
    <div class="rounded webview">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="font15 semi-bold text-center">TDSP</th>
            <th scope="col" class="font15 semi-bold text-center">Move In</th>
            <th scope="col" class="font15 semi-bold text-center">
              Priority Move In
            </th>
            <th scope="col" class="font15 semi-bold text-center">
              Self-Select Switch
            </th>
            <th scope="col" class="font15 semi-bold text-center last">
              Standard Switch<br />(3 - 7 Business Days)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of tduRates; let i = index">
            <td class="font15 font-weight-normal-calibre text-center">
              {{ loadActualUtilityName[element.Abbreviation] }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              ${{ checkForWholeOrDecimal(element.MoveInFee) }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              ${{ checkForWholeOrDecimal(element.PriorityMoveInFee) }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              ${{ checkForWholeOrDecimal(element.SwitchFee) }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="rounded mobileview text-center"
      style="float: left; width: 100%"
    >
      <div style="float: left; width: 50%">
        <table class="table" style="display: inline-block">
          <thead>
            <tr>
              <th scope="col" class="font15 semi-bold text-center">TDSP</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                AEP Central
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                AEP North
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                Centerpoint
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">NEC</td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                Oncor
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                Sharyland Utility
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                TNMP
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="float: left; width: 50%">
        <table class="table" style="display: inline-block">
          <thead
            style="height: 50px !important; vertical-align: middle !important"
          >
            <tr class="p-0">
              <th scope="col" class="font15 semi-bold text-center last">
                <a (click)="prevTab()" class="pull-left" *ngIf="tableIndex != 0"
                  ><img src="assets/images/left-arrow.png"
                /></a>
                {{ tableElements[tableIndex].thead }}
                <a
                  (click)="nextTab()"
                  class="pull-right"
                  *ngIf="tableIndex != 3"
                  ><img src="assets/images/right-arrow.png"
                /></a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of rowElements; let i = index">
              <td class="font15 font-weight-normal-calibre text-center last">
                {{ element }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
